/* BTS post-migration fixes. Loaded after bts-store.js.

   CART FIX — "Required parameter missing or invalid: id"
   ------------------------------------------------------
   sections/bts-product-buybox.liquid renders the optional warranty add-on as
   two hidden inputs:

     <input name="items[1][id]"       ... disabled>   <- disabled by default
     <input name="items[1][quantity]" value="1">      <- NOT disabled

   bts-store.js only ever toggles the *id* input (`warrantyIdInput.disabled`),
   so every add-to-cart POSTs items[1][quantity] with no items[1][id]. Shopify
   rejects the whole request with "Required parameter missing or invalid: id",
   which broke checkout for every customer.

   Keep both inputs' disabled state in lockstep with the warranty checkbox. */
(function () {
  function wire(root) {
    var checkbox = root.querySelector('[data-bts-warranty-checkbox]');
    var idInput = root.querySelector('input[name="items[1][id]"]');
    var qtyInput = root.querySelector('input[name="items[1][quantity]"]');
    if (!idInput || !qtyInput) return;

    function sync() {
      var wanted = !!(checkbox && checkbox.checked);
      idInput.disabled = !wanted;
      qtyInput.disabled = !wanted;
    }

    sync();
    if (checkbox) checkbox.addEventListener('change', sync);

    // Belt and braces: re-sync immediately before the form serialises, in case
    // any other script re-enabled an input after load.
    var form = idInput.form;
    if (form) form.addEventListener('submit', sync);
  }

  function init() {
    var roots = document.querySelectorAll('[data-bts-buybox]');
    for (var i = 0; i < roots.length; i++) wire(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* SUPPORT PAGE -- remove the duplicate header and the Partnerships block.

   The page renders its title ("Frequently Asked Questions about Memorial QR
   Codes") from the `main` section, directly above the FAQ section's own <h1>
   ("Frequently Asked Questions"). The page body is empty, so the whole main
   section is redundant.

   CSS alone is unreliable here: Shopify renders JSON-template sections with
   ids like `shopify-section-template--123456__main`, not
   `shopify-section-main`, and the numeric template id is unknown at author
   time. Match on the id suffix instead, which holds for both forms. */
(function () {
  function cleanSupportPage() {
    var main = document.querySelector('main[data-template]');
    if (!main || !/faq/.test(main.dataset.template || '')) return;

    var sections = main.querySelectorAll('[id^="shopify-section"]');
    for (var i = 0; i < sections.length; i++) {
      var id = sections[i].id;
      if (/(^|__)shopify-section-main$/.test(id) || /__main$/.test(id) || id === 'shopify-section-main') {
        sections[i].remove();
        continue;
      }
      if (id.indexOf('section_6MHPJ4') !== -1) sections[i].remove();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanSupportPage);
  } else {
    cleanSupportPage();
  }
})();

/* PRODUCT PAGE -- gallery swipe, lighter images, rating label, sale price.

   sections/bts-product-buybox.liquid renders the gallery as ONE <img> that
   bts-store.js swaps by setting .src from the thumbnails' data-full attribute.
   Two problems with that:

     1. Nothing to swipe. On a phone the only way to change image was to hit a
        40px arrow or a thumbnail.
     2. Slow. The single <img> is requested at width=1200 with fetchpriority
        high, so a 390px-wide phone downloads a 1200px JPEG before anything
        else paints, and every swap downloads another full-size one.

   Rebuild it as a scroll-snap track holding every image, each with a proper
   srcset so the browser picks a size that fits the device. Only the first is
   eager; the rest are lazy. Styling lives in bts-fixes.css rule 15.

   bts-store.js has already bound its own click handlers by the time this runs
   (both scripts are `defer`, this one is second), so the arrows and thumbs are
   replaced with clones to drop those listeners before rebinding. Its closure
   keeps a reference to the old <img>, which is now detached and harmless. */
(function () {
  function sized(url, w) {
    if (!url) return url;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + w);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function buildSrcset(url) {
    var widths = [400, 600, 800, 1200];
    var out = [];
    for (var i = 0; i < widths.length; i++) {
      out.push(sized(url, widths[i]) + ' ' + widths[i] + 'w');
    }
    return out.join(', ');
  }

  function initGallery() {
    var main = document.querySelector('.bts-gallery-main');
    if (!main || main.getAttribute('data-bts-swipe') === '1') return;

    var thumbRow = document.querySelector('.bts-thumb-row');
    var oldThumbs = thumbRow ? thumbRow.querySelectorAll('.bts-thumb') : [];
    var urls = [];
    for (var i = 0; i < oldThumbs.length; i++) {
      var u = oldThumbs[i].getAttribute('data-full');
      if (u) urls.push(u);
    }
    var oldImg = main.querySelector('img');
    if (!urls.length) {
      if (!oldImg) return;
      urls = [oldImg.getAttribute('src')];
    }

    var track = document.createElement('div');
    track.className = 'bts-slides';
    for (var j = 0; j < urls.length; j++) {
      var img = document.createElement('img');
      img.src = sized(urls[j], 800);
      img.srcset = buildSrcset(urls[j]);
      img.sizes = '(min-width: 1024px) 46vw, 100vw';
      img.alt = '';
      img.width = 1200;
      img.height = 1200;
      img.decoding = 'async';
      if (j === 0) {
        img.loading = 'eager';
        img.setAttribute('fetchpriority', 'high');
      } else {
        img.loading = 'lazy';
      }
      track.appendChild(img);
    }
    if (oldImg && oldImg.parentNode) oldImg.parentNode.removeChild(oldImg);
    main.insertBefore(track, main.firstChild);
    main.setAttribute('data-bts-swipe', '1');

    var dots = main.querySelectorAll('.bts-gallery-dots span');

    /* Re-create the thumbs so bts-store.js's handlers do not also fire. */
    var thumbs = [];
    for (var k = 0; k < oldThumbs.length; k++) {
      var fresh = oldThumbs[k].cloneNode(true);
      oldThumbs[k].parentNode.replaceChild(fresh, oldThumbs[k]);
      thumbs.push(fresh);
    }

    function index() {
      if (!track.clientWidth) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function goTo(i) {
      var n = urls.length;
      var target = ((i % n) + n) % n;
      track.scrollTo({ left: target * track.clientWidth, behavior: 'smooth' });
    }

    var ticking = false;
    function sync() {
      ticking = false;
      var active = index();
      for (var a = 0; a < dots.length; a++) {
        dots[a].classList.toggle('is-active', a === active);
      }
      for (var b = 0; b < thumbs.length; b++) {
        thumbs[b].classList.toggle('is-active', b === active);
      }
    }
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(sync);
    }, { passive: true });

    for (var t = 0; t < thumbs.length; t++) {
      (function (idx) {
        thumbs[idx].addEventListener('click', function () { goTo(idx); });
      })(t);
    }

    ['prev', 'next'].forEach(function (dir) {
      var btn = main.querySelector('.bts-gallery-arrow.' + dir);
      if (!btn) return;
      var fresh = btn.cloneNode(true);
      btn.parentNode.replaceChild(fresh, btn);
      fresh.addEventListener('click', function () {
        goTo(index() + (dir === 'next' ? 1 : -1));
      });
    });

    sync();
  }

  /* The rating line read "Read what families say". Show the score instead, with
     no review count. Only replaced when it still holds that stock label, so a
     value typed into the section setting later is left alone. */
  function initRatingLabel() {
    var el = document.querySelector('.bts-buy-reviews-link .bts-underline');
    if (el && /read what families say/i.test(el.textContent || '')) {
      el.textContent = '4.8';
    }
  }

  /* The buy box printed variant.price only, so the compare-at price never
     appeared on the page even though the cart and the sticky bar both showed
     it. Read the real variant off the product's own .js endpoint rather than
     hardcoding, so it tracks whatever the price actually is. */
  function initSalePrice() {
    var priceEl = document.querySelector('.bts-buy-price');
    if (!priceEl || priceEl.getAttribute('data-bts-compare') === '1') return;
    var path = window.location.pathname.split('?')[0].replace(/\/$/, '');
    if (path.indexOf('/products/') === -1) return;
    priceEl.setAttribute('data-bts-compare', '1');

    var idInput = document.querySelector('input[name="items[0][id]"]');
    var wantId = idInput ? parseInt(idInput.value, 10) : 0;

    window.fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.variants || !data.variants.length) return;
        var variant = data.variants[0];
        for (var i = 0; i < data.variants.length; i++) {
          if (wantId && data.variants[i].id === wantId) {
            variant = data.variants[i];
            break;
          }
        }
        if (!variant.compare_at_price || variant.compare_at_price <= variant.price) return;
        var was = document.createElement('span');
        was.className = 'bts-was';
        was.textContent = '$' + (variant.compare_at_price / 100).toFixed(2);
        priceEl.appendChild(document.createTextNode(' '));
        priceEl.appendChild(was);
      })
      .catch(function () { /* price simply stays as rendered */ });
  }

  function init() {
    initGallery();
    initRatingLabel();
    initSalePrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
